import { render, staticRenderFns } from "./BcIntermediarySet.vue?vue&type=template&id=38ec0ead&scoped=true&"
import script from "./BcIntermediarySet.vue?vue&type=script&lang=js&"
export * from "./BcIntermediarySet.vue?vue&type=script&lang=js&"
import style0 from "./BcIntermediarySet.vue?vue&type=style&index=0&id=38ec0ead&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ec0ead",
  null
  
)

export default component.exports